module.exports = __webpack_public_path__ + "img/user_avatar.32ddd7aa.png";